export default "__VITE_ASSET__BJnUnIDa__"